import { getNews } from "@/api/common";
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.getLeftAnnouncements();
  },
  methods: {
    getLeftAnnouncements() {
      getNews({ count: 8, page: 0 }).then((res) => {
        if (res.code == 200) {
          this.list = res.data.items;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
